// extracted by mini-css-extract-plugin
export default {"modal":"resumeSubscriptionModal_modal__Cmv+t"};